export enum OperatingSystem{
  WINDOWS_PHONE = 'Windows Phone',
  ANDROID = 'Android',
  IOS = 'IOS',
  UNKNOWN = 'Unknown'
}